export default __webpack_public_path__ + "static/power-of-a-dollar-header-4b9c94ea95edc4c5bd9a1ca6a3a24b3171b542787ddf880e1d16688e8a2fee8e.png";